<template>
  <div>
    <div class="mb-5">
      <span class="caption font-weight-bold"> クエリ </span>
      <v-divider />
      <p class="body-1 mt-2">
        {{ order.query }}
      </p>
    </div>
    <div class="mb-5">
      <span class="caption font-weight-bold"> キーワード </span>
      <v-divider />
      <div class="mt-2 pl-3">
        <div v-for="(words, rank) in order.rankKeywords" :key="rank">
          <span class="caption font-weight-bold"> {{ rank }}ランク </span>
          <v-divider />
          <p class="body-1 mt-2">
            <span v-for="word in words" :key="word">
              {{ word }}
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="mb-5">
      <span class="caption font-weight-bold"> 最低文字数 </span>
      <v-divider />
      <p class="body-1 mt-2">{{ order.requiredWords }}文字</p>
    </div>
    <div v-if="order.instruction">
      <span class="caption"> 詳細 </span>
      <v-divider />
      <p class="mt-2 body-2">
        <markdown-preview :source="order.instruction" />
      </p>
    </div>
  </div>
</template>

<script>
import MarkdownPreview from '@/components/commons/MarkdownPreview'

export default {
  components: {
    MarkdownPreview
  },
  props: {
    order: {
      type: Object,
      required: true
    }
  }
}
</script>
